import type { ProductSupportEligibilityResult } from '@/services/getProductSupportEligibilityV2';

type ProductId = NonNullable<ProductSupportEligibilityResult['productId']>;

export type ProductSupportSuccessState =
  | { showSuccess: false }
  | { showSuccess: true; productId?: ProductId; prefillMessage?: string };

export function getProductSupportSuccessState(
  eligibility: ProductSupportEligibilityResult | null | undefined,
  message: string
): ProductSupportSuccessState {
  if (!eligibility?.isEligible) {
    return { showSuccess: false };
  }

  const trimmedMessage = message.trim();

  if (!eligibility.productId) {
    return {
      showSuccess: true,
      prefillMessage: trimmedMessage.length > 0 ? trimmedMessage : undefined,
    };
  }

  return {
    showSuccess: true,
    productId: eligibility.productId,
    prefillMessage: trimmedMessage.length > 0 ? trimmedMessage : undefined,
  };
}
